import { Pipe } from '@angular/core';

@Pipe({
    name: 'InstitutionPipe'
})
export class InstitutionPipe {

    transform(value, args?) {
        const [searchString, hasOutcomesOnly] = args;
        return value.filter(institution => {
            return (institution.hasOutcomes || !hasOutcomesOnly) &&
                (searchString == null || searchString === '' || (this.isNumeric(searchString) && institution.id === parseInt(searchString)) || institution.name.toLowerCase().includes(searchString.toLowerCase()));
        });
    }

    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
}


/** WEBPACK FOOTER **
 ** ./app/institution/institutionPipe.ts
 **/